import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './api/http'
import { toPriceFormat, addSpPriceMark } from './utils/format'

Vue.config.productionTip = false

// グローバルフィルター
Vue.filter('toPriceFormat', function (val) {
  return toPriceFormat(val)
})
Vue.filter('addSpPriceMark', function (val, pid) {
  return addSpPriceMark(val, pid)
})

store.dispatch('auth/autoLogin').then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
})
